import { Styled } from "./styles";
import { SimpleLogView } from "./SimpleLogView";
import { UpdateLogView } from "./UpdateLogView";
import { UserWithAvatar } from "../UserWithAvatar";
import { actionsLabel } from "../../utils/entityActions";
import { DatetimeFormat } from "@screencloud/screencloud-ui-components";
import { capitalizeEachWord } from "src/utils";
import DateTime from "src/components/DateTime";
import { LogDetailsProps, isCreateAction, isDeleteAction } from "./utils";

export const LogDetails = (props: LogDetailsProps): JSX.Element => {
  return (
    <Styled>
      <div className="header">
        <UserWithAvatar user={props.user} />
        <div className="entity-container">
          <span className="entity-label">
            {actionsLabel[props.log.action!]}{" "}
            {capitalizeEachWord(props.log.objectType ?? "", "_")}
          </span>
          <span className="entity-timestamp">
            <DateTime
              value={props.log.timestamp}
              format={DatetimeFormat.Short}
            />
          </span>
        </div>
      </div>
      {isCreateAction(props.log.action!) ||
      isDeleteAction(props.log.action!) ? (
        <SimpleLogView log={props.log} />
      ) : (
        <UpdateLogView log={props.log} />
      )}
    </Styled>
  );
};
